import type * as api from '@gitbook/api-client';
import { arrayOfAll } from '@gitbook/util-ts';

export type ContentRefKind = api.ContentRef['kind'];

export const CONTENT_REF_KINDS = arrayOfAll<ContentRefKind>()([
    'user',
    'collection',
    'space',
    'page',
    'anchor',
    'file',
    'url',
    'reusable-content',
    'openapi',
]);
